import React from 'react';
import PropTypes from 'prop-types';
import { FadeLoader } from 'react-spinners';
import { css } from '@emotion/react';
import { useTranslation } from 'react-i18next';

import './Spinner.scss';

const override = css`
  display: block;
  margin: 0 auto;
`;

const Spinner = ({ spinnerSize = 150, hideText = false, noHeight = false, customText }) => {
  const { t } = useTranslation();
  return (
    <div className={`sweet-loading ${noHeight ? 'no-height' : ''}`}>
      <FadeLoader className={override} sizeUnit="px" size={spinnerSize} color="#042E60" loading />
      {!hideText && !customText && <p className="pt-1 text-strong">{t('common.labels.loading')}</p>}
      {customText && <p className="pt-1 text-strong">{customText}</p>}
    </div>
  );
};

Spinner.propTypes = {
  spinnerSize: PropTypes.number,
  hideText: PropTypes.bool,
  noHeight: PropTypes.bool,
  customText: PropTypes.string,
};

export default Spinner;
